export var ThemeFamilies;
(function (ThemeFamilies) {
    ThemeFamilies["PRIMARY"] = "primary";
    ThemeFamilies["SECONDARY"] = "secondary";
    // Thirdary in design system
    ThemeFamilies["TERTIARY"] = "tertiary";
    ThemeFamilies["ERROR"] = "error";
    ThemeFamilies["SUCCESS"] = "success";
    ThemeFamilies["WARNING"] = "warning";
    ThemeFamilies["INFO"] = "info";
    ThemeFamilies["DEFAULT"] = "default";
    ThemeFamilies["DECORATIVE_BLUE"] = "decorative_blue";
    ThemeFamilies["DECORATIVE_PURPLE"] = "decorative_purple";
    ThemeFamilies["DECORATIVE_BEIGE"] = "decorative_beige";
    ThemeFamilies["DECORATIVE_PINK"] = "decorative_pink";
    ThemeFamilies["DECORATIVE_TURQUOISE"] = "decorative_turquoise";
    ThemeFamilies["DECORATIVE_RED_LIGHT"] = "decorative_red_light";
    ThemeFamilies["GREY"] = "grey";
    ThemeFamilies["BORDERED_PRIMARY"] = "bordered_primary";
    ThemeFamilies["CIRCLED_PRIMARY"] = "circled_primary";
})(ThemeFamilies || (ThemeFamilies = {}));
